// domain/entities/CajaSesion.js
export class CajaSesion {
  constructor({
    id_sesion,
    fecha_apertura,
    fecha_cierre = null,
    id_usuario_apertura,
    id_usuario_cierre = null,
    saldo_inicial,
    saldo_final = null,
    estado,
    punto,
    observaciones = null,
  }) {
    // pilas porque aca se transformo tipo de snake_case a camelCase
    this.idSesion  = id_sesion;
    this.fechaApertura = fecha_apertura;
    this.fechaCierre = fecha_cierre;
    this.usuarioAperturaId = id_usuario_apertura;
    this.usuarioCierreId = id_usuario_cierre;
    this.saldoInicial = saldo_inicial;
    this.saldoFinal = saldo_final;
    this.estado = estado;
    this.punto = punto;
    this.observaciones = observaciones;
  }

  estaAbierta() {
    return this.estado === "abierta";
  }

  estaCerrada() {
    return this.estado === "cerrada";
  }
}